import { createFileRoute } from "@tanstack/react-router";
import { cn } from "cn";
import z from "zod";
import ResponsiveWrapper from "@/components/ui/layout/box/responsive-wrapper";
import PublicLayout from "@/components/ui/layout/public-layout";
import { SignIn } from "@/features/auth/sign-in";

export const Route = createFileRoute("/(auth)/sign-in")({
  component: SignInPage,
  validateSearch: z.object({
    redirect_url: z.string().optional(),
    method: z.enum(["phone", "email"]).default("phone"),
    identifier: z.string().optional(),
  }),
});

function SignInPage() {
  return (
    <PublicLayout>
      <ResponsiveWrapper
        className={cn(
          /* sorted */
          "grow",
          "py-12",
          "sm:mx-auto sm:w-full sm:max-w-[25.5rem]",
        )}
      >
        <SignIn />
      </ResponsiveWrapper>
    </PublicLayout>
  );
}
